import {useState, MouseEvent, useContext} from 'react';

import {useTranslation} from 'react-i18next';

// Material UI
import {Avatar, Box, IconButton, Menu, MenuItem, Typography} from '@mui/material';

import {LanguageContext} from '../../contexts/LanguageContext/LanguageContext';
import {SUPPORTED_LANGUAGES} from '../../lib/constants';

export const FlagLanguageSwitcher = () => {
  const {i18n, t} = useTranslation();
  const currentLanguage = useContext(LanguageContext);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  const handleOpenUserMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleSettingClick = (language: string) => {
    changeLanguage(language);
    handleCloseUserMenu();
  };

  return (
    <Box sx={{flexGrow: 0, display: 'flex'}}>
      <IconButton onClick={handleOpenUserMenu}>
        <Avatar
          sx={{
            bgcolor: 'transparent',
            '&:hover': {
              bgcolor: 'rgba(212, 212, 212, 0.5)',
            },
          }}
        >
          <span className={`fi fi-${currentLanguage === 'en' ? 'gb' : 'de'}`}></span>
        </Avatar>
      </IconButton>
      <Menu
        sx={{
          mt: '45px',
          '& .MuiMenuItem-root': {
            '&:hover': {
              bgcolor: 'background.default',
              borderRadius: '4px',
            },
          },
          '.MuiMenu-paper': {
            backgroundColor: 'background.menu',
          },
        }}
        id='menu-appbar'
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {SUPPORTED_LANGUAGES.map((language) => (
          <MenuItem
            key={language.id}
            onClick={() => handleSettingClick(language.id)}
            sx={{mx: '8px', color: 'primary.dark'}}
          >
            <Avatar sx={{bgcolor: 'transparent'}}>
              <span className={`fi fi-${language.flag}`}></span>
            </Avatar>
            <Typography textAlign='center'>{t(`shared.languages.${language.id}`)}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
